<template>
  <div class="bg-white p-5 pb-1 mb-3 rounded">
    <div class="d-lg-flex align-items-center justify-content-between mb-4 gap-2">
      <div class="justify-content-star d-flex">
        <h3><strong style="color:#1A0054">Planes</strong></h3>
      </div>
      <div class="justify-content-center d-lg-flex d-md-flex d-sm-grid">
        <search-input-component :search="search" @onSearch="onFilterSearch"></search-input-component>
      </div>
    </div>

    <plan-table
      :plans="filteredPlans"
      :loading="loading"
      :current-page="currentPage"
      :page-count="pageCount"
      :items-per-page="itemsPerPage"
      @edit-plan="openEditModal"
      @delete-plan="openDeleteModal"
      @page-change="handlePageChange"
    />

    <plans-create-component
      :get="get"
      @updatetable="onUpdateData"
    />

    <modal-delete-plan
      v-if="deleteModalVisible"
      :plan="selectedPlan"
      :url="get"
      @reloadtable="onReloadTable"
      @close="closeDeleteModal"
    />
    
    <modal-edit-plan
      v-if="editModalVisible"
      :plan="selectedPlan"
      :get="get"
      @reloadtable="onReloadTable"
      @close="closeEditModal"
    />
  </div>
</template>
<script>
import PlanTable from './PlanTable.vue'
import ModalDeletePlan from './ModalDeletePlan.vue'
import ModalEditPlan from './ModalEditPlan.vue'

export default {
  components: {
    PlanTable,
    ModalDeletePlan,
    ModalEditPlan
  },
  
  props: {
    get: String
  },
  
  data() {
    return {
      plans: [],
      loading: false,
      search: '',
      currentPage: 1,
      itemsPerPage: 10,
      deleteModalVisible: false,
      editModalVisible: false,
      selectedPlan: {}
    }
  },
  
  computed: {
    filteredPlans() {
      if (!this.search) return this.plans
      return this.plans.filter(plan => 
        plan.name.toLowerCase().includes(this.search.toLowerCase())
      )
    },
    pageCount() {
      return Math.ceil(this.filteredPlans.length / this.itemsPerPage)
    }
  },
  
  mounted() {
    this.getData()
  },
  
  methods: {
    async getData() {
      this.loading = true
      try {
        const response = await axios.get(this.get)
        this.plans = response.data
      } catch (error) {
        console.error('Error loading plans:', error)
      } finally {
        this.loading = false
      }
    },
    
    onUpdateData() {
      this.$emit('updatedata')
      this.getData()
    },
    
    onFilterSearch(searchText) {
      this.search = searchText
    },
    
    handlePageChange(page) {
      this.currentPage = page
    },
    
    openDeleteModal(plan) {
      this.selectedPlan = plan
      this.deleteModalVisible = true
    },
    
    openEditModal(plan) {
      this.selectedPlan = plan
      this.editModalVisible = true
    },
    
    closeDeleteModal() {
      this.deleteModalVisible = false
    },
    
    closeEditModal() {
      this.editModalVisible = false
    },
    
    onReloadTable() {
      this.getData()
    }
  }
}
</script>
